import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.timeout = null
    this._boundCloseOnClickOutside = this._closeOnClickOutside.bind(this)
    document.addEventListener("click", this._boundCloseOnClickOutside)
  }

  show() {
    if (this.timeout) clearTimeout(this.timeout)
    this.menuTarget.classList.remove("hidden")
  }

  hide() {
    this.timeout = setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 150)
  }

  cancelHide() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.menuTarget.classList.contains("hidden")

    // Close all other dropdowns first
    document.querySelectorAll('[data-dropdown-target="menu"]').forEach(menu => {
      menu.classList.add("hidden")
    })

    if (isHidden) {
      this.menuTarget.classList.remove("hidden")
    }
  }

  _closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    document.removeEventListener("click", this._boundCloseOnClickOutside)
  }
}
